<template>
  <footer class="main-footer footer-four bgs-cover">
    <div class="fbg2">
      <div class="container2">
        <div class="row justify-content-between">
          <div class="col-lg-3 col-sm-2 w-20p">
            <div class="footer-widget link-widget rml-0">
              <h5 class="mega-title footer-bold m-left2">
               <router-link class="nav-bold" to="/enterprise-banking-services#BankingExpertise">{{ $t('footer.bankingExpertise') }}</router-link>
              </h5>
              <ul class="lhf">
               
                  <li>
                    <router-link to="/enterprise-banking-services#RealTimePayments">{{ $t('footer.realTimePayments') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#InterbankPayments">{{ $t('footer.interbankPayments') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#BankingExpertise">{{ $t('footer.qrBasedPayments') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#PaymentRoutingandWorkflows">{{ $t('footer.paymentRoutingWorkflows') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#BankingExpertise">{{ $t('footer.accountingServices') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#BankingExpertise">{{ $t('footer.reconciliationServices') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#CorporateBankingPortal">{{ $t('footer.corporateBankingPortal') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#ComplianceandSecurity">{{ $t('footer.complianceSecurity') }}</router-link>
                  </li>
              </ul>
            </div>
          </div>


          <div class="col-lg-2 col-sm-2 w-20p">
            <div class="footer-widget link-widget rml-0">
              <h5 class="mega-title footer-bold m-left2">
               <router-link class="nav-bold" to="/enterprise-banking-services#EnterpriseExpertise">{{ $t('footer.enterpriseExpertise') }}</router-link>
              </h5>
              <ul class="lhf">
                 <li>
                    <router-link to="/enterprise-banking-services#DataProcessing">{{ $t('footer.dataProcessing') }}</router-link>
                  </li>
                   <li>
                    <router-link to="/enterprise-banking-services#CRMBusinessSolutions">{{ $t('footer.CRMERPBusinessSolutions') }}</router-link>
                  </li>
                   <li>
                    <router-link to="/enterprise-banking-services#DataEngineering">{{ $t('footer.dataEngineering') }}</router-link>
                  </li>
                   <li>
                    <router-link to="/enterprise-banking-services#BusinessIntelligence">{{ $t('footer.businessIntelligence') }}</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">{{ $t('footer.enterpriseArchitecture') }}</router-link>
                  </li> -->
                  <li>
                    <router-link to="/enterprise-banking-services#ProcessandWorkflowAutomation">{{ $t('footer.processWorkflowAutomation') }}</router-link>
                  </li>
                  <li>
                    <router-link to="/enterprise-banking-services#CloudMigrationServices">{{ $t('footer.cloudMigrationServices') }}</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/enterprise-banking-services#CentralizedEventMonitoringHub">{{ $t('footer.centralizedEventMonitoring') }}</router-link>
                  </li> -->
                  <li>
                    <router-link to="/enterprise-banking-services#LegacySystemTransformation">{{ $t('footer.legacyTransformation') }}</router-link>
                  </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-sm-2 w-20p">
            <div class="footer-widget link-widget rml-0">
              <h5 class="mega-title footer-bold m-left2">
                <router-link to="/service-digital">{{ $t('footer.digitalServices') }}</router-link>
              </h5>
              <ul class="lhf">
                <li>
                  <router-link to="/service-digital#MobileAppDevelopment">{{ $t('footer.mobileAppDevelopment') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#FrontendDevelopment">{{ $t('footer.frontendDevelopment') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#BackendDevelopment">{{ $t('footer.backendDevelopment') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#APIDevelopment">{{ $t('footer.apiDevelopment') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#CrossPlatformAppDevelopment">{{ $t('footer.crossPlatformAppDevelopment') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#DigitalAssetManagement">{{ $t('footer.digitalAssetManagement') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-digital#OurProducts">{{ $t('footer.ourProducts') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-sm-3 w-20p">
            <div class="footer-widget contact-widget rmr-0">
              <h5 class="mega-title footer-bold m-left2">
                <router-link to="/ai-automations">{{ $t('footer.aiAutomations') }}</router-link>
              </h5>
              <ul class="lhf">
                <li>
                  <router-link to="/ai-automations#chatbots">{{ $t('footer.chatbotsAgents') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#hrautomation">{{ $t('footer.hrAutomation') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#ocr">{{ $t('footer.ocrDocumentProcessing') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#workfloworchestration">{{ $t('footer.workflowOrchestration') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#itsupport">{{ $t('footer.itSupportAssistant') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#intelligentprocess">{{ $t('footer.intelligentProcessAutomation') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#itproductionsupport">{{ $t('footer.itProductionSupport') }}</router-link>
                </li>
                <li>
                  <router-link to="/ai-automations#internalknowledge">{{ $t('footer.internalKnowledgeBase') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 w-20p">
            <div class="footer-widget contact-widget rmr-0">
              <h5 class="mega-title footer-bold m-left2">
                <router-link to="/service-cloud">{{ $t('footer.cloudServices') }}</router-link>
              </h5>
              <ul class="lhf">
                <li>
                  <router-link to="/service-cloud#cloudmigration">{{ $t('footer.cloudMigrationModernization') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-cloud#devops">{{ $t('footer.devopsAsService') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-cloud#paas">{{ $t('footer.platformAsService') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-cloud#cloudmonitoring">{{ $t('footer.cloudMonitoringCostControl') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-cloud#cloudsecurity">{{ $t('footer.cloudSecurityCompliance') }}</router-link>
                </li>
                <li>
                  <router-link to="/service-cloud#multicloud">{{ $t('footer.multiCloudHybridStrategy') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fbg1">
      <div class="container2">
        <div class="row logo-btm-line">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="about-widget d-flex justify-content-between align-items-center">
              <div class="footer-logo mb-0 fl ftr-align">
                <router-link to="/">
                  <img src="/assets/images/logos/opalina_logo.png" alt="Logo">
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 d-ftr-flex">
            <div class="contact-widget rmr-0 dis-b">
              <div class="mail-i d-flex">
                <img src="/assets/images/services/mail-f.png">
                <p>
                  <a class="email_flex" href="mailto:contact@opalina.com?subject=Connect with us">
                    <span>{{ $t('footer.emailUsAt') }}</span>
                    <span>contact@opalina.com</span>
                  </a>
                </p>
              </div>
            </div>
            <div class="contact-widget rmr-0 dis-n text-center">
              <div class="mail-i pt-30">
                <img src="/assets/images/services/mail-f.png">
                <p>
                  <a href="mailto:contact@opalina.com?subject=Connect with us">
                    <span>{{ $t('footer.emailUsAt') }}</span><br>
                    contact@opalina.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-area bg-opal text-white f-bt">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <p class="copyright mb-0">{{ $t('footer.copyright') }}</p>
          <div class="footer-links">
            <router-link to="/privacy-policy" class="footer-link">{{ $t('footer.privacyPolicy') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
/* Footer styles are handled by existing CSS */
.footer-links {
  display: flex;
  gap: 15px;
  align-items: center;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #69b9ac;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .copyright-area .d-flex {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .footer-links {
    justify-content: center;
  }
}
</style>
